import Axios from 'axios';
import {urlAPIDirectus} from "../config/Globals";

function findAll(){
    return Axios
        .get(urlAPIDirectus+"faq?filter[status][_eq]=published&fields=*,categorie.categorie_faq_id.*")
        .then(response => response.data.data);
}

function findAllInCateg(categId){
    return Axios
        .get(urlAPIDirectus+"faq?filter[status][_eq]=published&fields=*,categorie.categorie_faq_id.*&filter[categorie][categorie_faq_id][_eq]="+categId)
        .then(response => response.data.data);
}
function find(id){
    return Axios
        .get(urlAPIDirectus+"faq/"+id+"?filter[status][_eq]=published")
        .then(response => response.data.data);
}

function search(search){
    return Axios
        .get(urlAPIDirectus+"faq?filter[status][_eq]=published&filter[_or][0][titre][_icontains]="+search+"&filter[_or][1][contenu][_icontains]="+search+'&fields=*.*')
        .then(response => response.data.data);
}

export default {
    findAll, find, findAllInCateg,search
}